import { MessageBarType } from '@fluentui/react/lib/MessageBar';
import { createGlobalState } from 'react-hooks-global-state';

export interface Message {
  text: string;
  type: MessageBarType;
}

interface Settings {
  darkTheme: boolean;
  pendingCategory: boolean;
  showAllTasks: boolean;
}

interface GlobalState {
  settings: Settings;
  message: Message;
}

const globalState: GlobalState = {
  settings: { 
    darkTheme: false,
    pendingCategory: false,
    showAllTasks: false,
  },
  message: null,
}

export const { useGlobalState, getGlobalState, setGlobalState } = createGlobalState(globalState);

export const showMessage = (message: Message) => setGlobalState('message', message);

export const dismissMessage = () => setGlobalState('message', null);